<template>
	<ButtonShare :loading="isLoading" @click="share">
		<template #icon><BaseIcon name="jira" /></template>
		Share in Jira
	</ButtonShare>
</template>

<script>
import analytics from 'shared/utils/analytics'
import ButtonShare from 'shared/components/ButtonShare.vue'

export default {
	name: 'ButtonShareJira',
	components: {ButtonShare},
	props: {
		workspaceId: {type: String, required: true},
	},
	emits: ['click'],
	data() {
		return {
			isLoading: false,
		}
	},
	methods: {
		async share() {
			analytics.track('Jira Share Button Clicked')
			this.isLoading = true
			try {
				const Jira = (await import('shared/integrations/jira')).default
				await new Jira(this.workspaceId).getAccessTokenCached()
				this.$routerHelpers.pushQueryParams({jira: 'create-issue', github: null, linear: null, azure: null})
			} catch (error) {
				if (error.message === 'Popup was closed') return
				if (error.message === 'Popup not opened') {
					this.$notify.error({
						title: 'Cannot open the pop up',
						message:
							'Cannot open the pop up for jira authentication. Please check your browser if it blocks the pop up.',
					})
					return
				}
				throw error
			} finally {
				this.isLoading = false
				this.$emit('click')
			}
		},
	},
}
</script>
